import { RadiusPixel, Sizes } from './sizes';
import { SpacingPixel } from './spacing';
export const ClerkAppearance = (theme) => {
    return {
        layout: {
            animations: false,
            shimmer: false,
            unsafe_disableDevelopmentModeWarnings: true,
        },
        elements: {
            logoBox: {
                display: 'none',
            },
            rootBox: {
                width: '100%',
            },
            cardBox: {
                border: 'none',
                borderRadius: 0,
                boxShadow: 'none',
                width: 'unset',
                maxWidth: 'unset',
                '&.cl-signIn-passwordPwnedMethods': {
                    marginBottom: 16,
                    '.cl-alternativeMethodsBlockButton': {
                        display: 'none',
                    },
                    '.cl-footerAction': {
                        display: 'none',
                    },
                },
            },
            card: {
                gap: SpacingPixel.xxlarge,
                boxShadow: 'none',
                padding: 1,
            },
            form: {
                gap: SpacingPixel.xxlarge,
            },
            formFieldInput: Object.assign(Object.assign({ lineHeight: 1.43, maxHeight: 'unset' }, theme.typography.bodyLargeLight), { borderColor: theme.palette.lightBorder.onclick, '&:hover, &:focus, &:active': {
                    borderColor: theme.palette.lightBorder.onclick,
                }, '&[data-variant="default"]': {
                    '&, &:hover, &:focus, &:focus-within, &:active': {
                        borderWidth: '1px',
                        boxShadow: 'none',
                    },
                    '&[data-feedback="error"]': {
                        '&, &:hover, &:focus, &:focus-within, &:active': {
                            borderColor: theme.palette.error.main,
                            boxShadow: 'none',
                        },
                    },
                }, '&::placeholder': Object.assign(Object.assign({}, theme.typography.bodyLargeLight), { color: theme.palette.typographyDarkSecondary.main }), padding: 12, borderRadius: RadiusPixel.base, fontSize: '0.875rem' }),
            formFieldLabel: Object.assign({}, theme.typography.labelSmall),
            formFieldCheckboxLabel: Object.assign(Object.assign({}, theme.typography.bodySmallLight), { a: {
                    color: theme.palette.typographyBrandPrimary.main,
                } }),
            formFieldAction: Object.assign(Object.assign({}, theme.typography.bodySmallLight), { color: theme.palette.typographyDarkSecondary.main }),
            formFieldAction__password: Object.assign(Object.assign({}, theme.typography.labelSmall), { color: theme.palette.typographyBrandPrimary.main }),
            formFieldInfoText: Object.assign({}, theme.typography.labelExtraSmall),
            formFieldSuccessText: Object.assign({}, theme.typography.labelExtraSmall),
            formFieldErrorText: Object.assign(Object.assign({}, theme.typography.labelExtraSmall), { color: theme.palette.error.main, svg: {
                    display: 'none',
                } }),
            button: {
                borderRadius: `${RadiusPixel.round}px`,
                height: Sizes.base,
                'svg.cl-buttonArrowIcon': {
                    display: 'none',
                },
                '&.cl-formButtonPrimary:hover': {
                    backgroundColor: theme.palette.brandPrimaryFill.hover,
                },
            },
            identityPreviewEditButton: {
                height: 'unset',
            },
            formFieldInputShowPasswordButton: {
                display: 'none',
            },
            headerTitle: Object.assign(Object.assign({}, theme.typography.h1), { textAlign: 'left' }),
            headerSubtitle: Object.assign(Object.assign({}, theme.typography.bodyLargeLight), { marginTop: SpacingPixel.small, textAlign: 'left' }),
            identityPreview: {
                justifyContent: 'flex-start',
            },
            footer: {
                background: 'none',
            },
            footerAction: {
                alignItems: 'center',
                gap: SpacingPixel.small,
            },
            footerActionText: Object.assign(Object.assign({}, theme.typography.bodySmallHeavy), { color: theme.palette.text.primary }),
            footerActionLink: Object.assign(Object.assign({}, theme.typography.link), { color: theme.palette.typographyBrandPrimary.main }),
        },
        variables: {
            fontFamily: theme.typography.body1.fontFamily,
            fontSize: `${theme.typography.body1.fontSize}px`,
            fontFamilyButtons: theme.typography.buttonLarge.fontFamily,
            borderRadius: `${RadiusPixel.base}px`,
            spacingUnit: `${SpacingPixel.base}px`,
            colorPrimary: theme.palette.brandPrimaryFill.default,
            colorDanger: theme.palette.dangerFill.default,
            colorSuccess: theme.palette.successFill.default,
            colorWarning: theme.palette.warningFill.default,
            colorNeutral: theme.palette.neutralFill.default,
            colorText: theme.palette.text.primary,
            colorTextSecondary: theme.palette.text.secondary,
            colorInputText: theme.palette.text.primary,
        },
    };
};
